module.exports = __webpack_public_path__ + "img/edit.04b71de0.svg";